import React, {useEffect, useMemo, useState} from 'react';
import {Tab, Button, Grid, Icon, Input, Segment, Form} from 'semantic-ui-react';
import {BonusConfigsFilter} from "../../../../filters/bonus-configs-filter";
import {useBlockUI} from "../../../../shared/services/block-ui-service";
import SessionStorage from "../../../../store/session";
import {SessionUser} from "../../../../models/session-user";
import {useLocation, useNavigate} from "react-router-dom";
import BonusConfigListComponent from "./components/BonusEngineLoadConfigList";
import {ShortDto} from '../../../../models/short-dto';
import useVehiclePlateService from 'services/backoffice/hooks/useVehiclePlateService';


const BonusConfigsList = () => {
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [filter, setFilter] = useState<BonusConfigsFilter>({});
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [activeIndex, setActiveIndex] = useState<number>();
    const [fleetId, setFleetId] = useState<string | null>(null); // Estado para armazenar o fleetId
    const location = useLocation();
    const navigate = useNavigate();
    const [showFilters, setShowFilters] = useState(false);
    const [clientes, setClientes] = useState<ShortDto[]>([]); // Para popular futuramente
    const [vehiclePlates, setVehiclePlates] = useState<ShortDto[]>([]);
    const [fleetTypes, setFleetTypes] = useState<ShortDto[]>([]);

    const {getAllVehiclePlatesShortDto} = useVehiclePlateService();


    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])

    useEffect(() => {
        listPlates();
    }, [filter?.Page]);

    async function listPlates() {
        setLoading(true)
        const response = (await getAllVehiclePlatesShortDto(filter).finally(() => setLoading(false)));
        setVehiclePlates(response);
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('operationId');
        const tab = params.get('tab');
        setFleetId(id);
        if (tab === 'inertia') {
            setActiveIndex(1);
        } else if (tab === 'engineLoadException') {
            setActiveIndex(2);
        } else {
            setActiveIndex(0);
        }
    }, [location.search]);



    const panes = useMemo(() => [
        {
            menuItem: 'Listagem de Premiações de Carga no motor',
            render: () => <Tab.Pane>
                <BonusConfigListComponent key={'EngineLoad'} filterType={'EngineLoad'} filterFleetId={fleetId} filter={filter}/>
            </Tab.Pane>
        },
        {
            menuItem: 'Listagem de Premiações de Inércia',
            render: () => <Tab.Pane>
                <BonusConfigListComponent key={'Inertia'} filterType={'Inertia'} filterFleetId={fleetId} filter={filter}/>
            </Tab.Pane>
        },
        {
            menuItem: 'Listagem de Premiações de Excessão de Carga no motor',
            render: () => <Tab.Pane>
                <BonusConfigListComponent key={'EngineLoadException'} filterType={'EngineLoadException'} filterFleetId={fleetId} filter={filter}/>
            </Tab.Pane>
        },
    ], [fleetId, filter]);

    return (
        <div>
            {activeIndex === 2 && (
                <>
                    <Button onClick={() => setShowFilters(!showFilters)} color="green">
                        <Icon name={showFilters ? 'hide' : 'unhide'} />
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                    {showFilters && (
                        <Segment>
                            <Grid stackable doubling padded>
                                <Grid.Row>
                                    <Grid.Column width={3}>
                                        <Form.Select
                                            options={vehiclePlates}
                                            placeholder="Placa"
                                            value={filter.vehiclePlateId ?? ''}
                                            search
                                            clearable
                                            onChange={(e, data) => setFilter({ ...filter, vehiclePlateId: data.value as string })}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={1} verticalAlign="bottom">
                                        <Button color="green" onClick={() => setFilter({ ...filter })}>Buscar</Button>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    )}
                </>
            )}
            <Tab
                menu={{fluid: true, vertical: false, tabular: true}}
                panes={panes}
                activeIndex={activeIndex}
                onTabChange={(e, {activeIndex}) => {
                    setActiveIndex(typeof activeIndex === 'string' ? parseInt(activeIndex, 10) : activeIndex);
                }}
            />
        </div>
    );
};

export default BonusConfigsList;
